import React from 'react';
import Header from './Header';
import Footer from './Footer';
import AskJigsawChat from '@/components/chat/AskJigsawChat';
import CookieConsent from '@/components/gdpr/CookieConsent';
import SubscribeModal from '@/components/common/SubscribeModal';

export default function MainLayout({ children, hideChat = false }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      {/* AI Chatbot - shown on public pages */}
      {!hideChat && <AskJigsawChat />}
      {/* Cookie Consent Banner */}
      <CookieConsent />
      {/* Subscribe Modal */}
      <SubscribeModal />
    </div>
  );
}